/**
 * Table view of the companies list — the alternative to the cards.
 *
 * Same facts as a card, in columns that line up: what they do, where they are,
 * how much is open against them, who owns them and how many contacts sit under
 * them.
 */
import { useApp } from '../store/AppContext.jsx';
import Icon from '../lib/icons.jsx';
import { avatarClass } from '../lib/format.js';
import { EmptyState, OwnerPill, Pill, Dash } from './Primitives.jsx';
import { isOpen } from '../domain/crm.js';

export default function CompanyTable({ list }) {
  const { crm, rows, fmtMoney, setSheet } = useApp();

  if (!list.length) {
    return (
      <EmptyState icon="building" tone="g-cyan" title="No companies match">
        Clear the filters, or add one.
      </EmptyState>
    );
  }

  return (
    <div className="tscroll">
      <table>
        <thead>
          <tr>
            <th>Company</th><th>Industry</th><th>City</th><th>Open</th>
            <th>Open value</th><th>Owner</th><th>Contacts</th><th />
          </tr>
        </thead>
        <tbody>
          {list.map(c => {
            const open = crm.deals.filter(d => d.cid === c.id && isOpen(d));
            const contacts = crm.contacts.filter(x => x.cid === c.id).length;
            const isClient = rows.some(r => r.name === c.name);

            return (
              <tr key={c.id} onClick={() => setSheet({ kind: 'company', id: c.id })}>
                <td>
                  <div className="cname">
                    <span className={`who ${avatarClass(c.name)}`}><Icon name="building" /></span>
                    <div>
                      <b>{c.name}</b>
                      {isClient ? <small>client</small> : null}
                    </div>
                  </div>
                </td>
                <td>{c.industry || <Dash />}</td>
                <td>{c.city || <Dash />}</td>
                <td>
                  {open.length
                    ? <Pill tone="p-blue">{open.length} open</Pill>
                    : <span className="dim">none</span>}
                </td>
                <td><b>{fmtMoney(open.reduce((t, d) => t + (+d.value || 0), 0))}</b></td>
                <td><OwnerPill name={c.owner} /></td>
                <td className="dim">{contacts}</td>
                <td>
                  <div className="acts">
                    <button
                      type="button"
                      title="Edit"
                      onClick={e => { e.stopPropagation(); setSheet({ kind: 'company', id: c.id }); }}
                    >
                      <Icon name="edit" />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
